import { Component, OnInit } from '@angular/core';
import { FlashMessagesService } from 'flash-messages-angular';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-forgot-password-admin',
  templateUrl: './forgot-password-admin.component.html',
  styleUrls: ['./forgot-password-admin.component.css']
})
export class ForgotPasswordAdminComponent implements OnInit {

  // Email and template variable
  passwordReset: boolean = false;
  user = {
    email: ""
  }

  constructor(private auth: AuthService, private flashMessage: FlashMessagesService) { }

  ngOnInit(): void {
    console.log("component initialized")
  }

  // Send request to send email for password reset admin
  onSubmit() {
    this.auth.forgotAdminpassword({ email: this.user.email }).toPromise().then((data: any) => {

      // Change template
      this.passwordReset = true;
    });
  }
}
